export const mockUserType = [
  {
    id: '1',
    title: 'panel.header.title.particular'
  },
  {
    id: '2',
    title: 'panel.header.title.realestate'
  },
  {
    id: '3',
    title: 'panel.header.title.builder'
  },
  {
    id: '4',
    title: 'panel.header.title.broker'
  },
  {
    id: '5',
    title: 'panel.header.title.agency'
  },
  {
    id: '6',
    title: 'panel.header.title.developer'
  }
];
